import styled from 'styled-components'
import { palette } from 'theme/palette'

export const ButtonLauncherContainer = styled.button`
  background-color: ${palette.transparent};
  border: none;
  border-radius: 50%;
  height: 70px;
  width: 70px;
  margin: 16px;
  cursor: pointer;
  filter: drop-shadow(0px 4px 8px rgba(27, 69, 113, 0.4));
  animation-duration: .4s;
  animation-name: appear;
  
  &:focus-visible {
    outline: 2px solid ${palette.mainBlue};
  }
`

export const LauncherImage = styled.img`
  width: 100%;
`
